import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-monitor-setting",
  "use": "app-icon-monitor-setting-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"app-icon-monitor-setting\"><g fill-rule=\"evenodd\"><path d=\"M14.5 18.429v1.285L15.75 21h-7.5l1.25-1.286V18.43H3a1 1 0 01-1-1V4a1 1 0 011-1h18a1 1 0 011 1v13.429a1 1 0 01-1 1h-6.5zM3.5 4.5v12h17v-12h-17z\" fill-rule=\"nonzero\" /><path d=\"M13.75 9.043l-1.125-1.157L17.5 6.214l-1.625 5.015-1.125-1.158-2.25 2.186-.875.9-1.75-1.928-2.625 2.828-.875-.9 3.5-3.728.875.9.875.9z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol